import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {GenderViewModel} from '../../../shared/viewModels/gender.viewModel';
import {BodyTypeViewModel} from '../../../shared/viewModels/bodyType.viewModel';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {UsersService} from '../../../shared/services/users.service';
import {NotificationsService} from '../../../shared/services/notification.service';
import {LocalisationService} from '../../../shared/services/localisation.service';
import {BsModalEventsEmitter} from '../../../shared/events/bsModal.events';
import {forkJoin} from 'rxjs';
import {UserProfileViewModel} from '../../../shared/viewModels/userProfile.viewModel';
// tslint:disable-next-line:max-line-length
import {DialCodeSelectorModalComponent} from '../../../shared/components/profile-sections/dial-code-selector-modal/dial-code-selector-modal.component';

@Component({
    selector: 'app-master-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsComponent implements OnInit {
    @Input() editable = true;
    @Input() notifications = true;
    @Input() useSwiper = true;

    loading = true;
    firstName: FormControl = new FormControl('', [Validators.required]);
    surname: FormControl = new FormControl('', [Validators.required]);
    phone: FormControl = new FormControl('', [Validators.required]);
    genders: GenderViewModel[];
    currentlySelectedGender: GenderViewModel;

    dialCodes: { [key: string]: string; };
    selectedPhoneDialCode = '';

    dialCodeModal: BsModalRef;

    constructor(
        private readonly usersService: UsersService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        private readonly notificationService: NotificationsService,
        private readonly localisationService: LocalisationService,
        private readonly bsModalService: BsModalService,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
    ) {
        // @ts-ignore
        this.dialCodes = require(`../../../../../../config/country_dial_codes.json`);
        this.selectedPhoneDialCode = '+359';
    }

    ngOnInit() {
        forkJoin(
            this.usersService.getUserGenders(),
        )
            .subscribe(([genders]) => {
                this.genders = genders;
                this.loading = false;

                this.changeDetectorRef.detectChanges();

                if (this.usersService.userProfile) {
                    this.initCurrentUserProfile(this.usersService.userProfile);
                }
            });
    }

    onGenderSelected(gender: string) {
        this.currentlySelectedGender = this.genders.find(g => g.gender === gender);
    }

    updateProfile() {
        this.loading = true;
        this.usersService.updateUserProfile({
            first_name: this.firstName.value,
            last_name: this.surname.value,
            dial_code: this.selectedPhoneDialCode,
            phone: this.phone.value,
            gender: {
                id: this.currentlySelectedGender.id
            }
        })
            .subscribe(() => {
                this.loading = false;
                this.changeDetectorRef.detectChanges();

                if (this.notifications) {
                    this.notificationService.success(this.localisationService.localise('settings_profile_updated_successfully'));
                }
            });
    }

    openDialCodeModal() {
        this.dialCodeModal = this.bsModalService.show(DialCodeSelectorModalComponent, {
            backdrop: true
        });

        this.dialCodeModal.content.personalOrWizardComponent = this;
        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.dialCodeModal);
    }

    get saveButtonIsDisabled(): boolean {
        return !this.phone.valid || !this.firstName.valid || !this.surname.valid || !this.currentlySelectedGender;
    }

    private initCurrentUserProfile(userProfile: UserProfileViewModel) {
        this.firstName.setValue(userProfile.first_name);
        this.surname.setValue(userProfile.last_name);
        this.phone.setValue((userProfile.phone === null ? '' : userProfile.phone));

        if (userProfile.dial_code !== null && userProfile.dial_code.length > 0) {
            this.selectedPhoneDialCode = userProfile.dial_code;
        }

        this.currentlySelectedGender = userProfile.gender ? this.genders.find(g => g.id === userProfile.gender.id) : undefined;

        this.changeDetectorRef.markForCheck();
    }

    onDialCodeChange(event) {
        this.selectedPhoneDialCode = event.target.value;
        this.changeDetectorRef.markForCheck();
    }

}
